module.exports = __webpack_public_path__ + "img/wizard_wechat-official.4030108a.jpeg";